import PropTypes from 'prop-types'
import { Link } from 'wouter'

export default function SubMenuItems({
  submenu,
  location,
  isSidebarOpen,
  setIsSidebarOpen
}) {
  return (
    <li className="flex" title={submenu?.title} key={submenu?.title}>
      {/* 
        Explicación de las validaciones en 'className':
          - Se resalta el ítem si el usuario está dentro.
          - Si la URL contiene el slug padre del submenú, se resalta el ítem desde donde se accedió (esto es útil cuando accedemos a un ítem de una lista y nos lleva a un formulario, permitiendo resaltar la página de origen).
          - Si el ítem está activo y no se cumplen las condiciones anteriores, se le agrega una animación de hover.
      */}
      <Link
        href={submenu.slug}
        className={`inline-flex items-center pr-3 pl-4 ml-2.5 py-1.5 text-base text-white duration-300 grow border-s-2 whitespace-nowrap text-ellipsis ${
          submenu?.slug === location || location.startsWith(submenu.parentSlug)
            ? '*:text-accent border-accent'
            : submenu?.active &&
              'border-white text-white hover:border-accent hover:text-accent'
        }`}
        onClick={() => {
          if (setIsSidebarOpen) {
            setIsSidebarOpen(false)
          }
        }}
      >
        <div className="w-1/6 my-auto">{submenu?.icon}</div>

        <div
          className={`w-5/6 ml-0 md:ml-3 flex items-center uppercase origin-left duration-75 ${!isSidebarOpen && 'scale-0'}`}
        >
          <span>{submenu?.title}</span>
        </div>
      </Link>
    </li>
  )
}

SubMenuItems.propTypes = {
  submenu: PropTypes.object,
  location: PropTypes.any,
  isSidebarOpen: PropTypes.any,
  setIsSidebarOpen: PropTypes.any
}
